import axios from 'axios';
import api from '../config/axios';
import API_ROUTES from '../config/apiRoutes';

// --- Importamos los tipos necesarios ---
import { ApiResponse } from '../interfaces/api.types';
import { DashboardSummary } from '../interfaces/dashboard.types';

// --- (Reutilizar o importar handleApiError) ---
const handleApiError = (error: unknown): never => {
    if (axios.isAxiosError(error) && error.response) {
        throw new Error(error.response.data.message || 'Ocurrió un error en el servidor.');
    }
    throw new Error('Ocurrió un error de conexión o un problema desconocido.');
};

/**
 * @function getDashboardSummary
 * @description Obtiene el conjunto de datos de resumen para el Dashboard principal.
 * @returns {Promise<DashboardSummary>} Un objeto con KPIs, agenda y casos recientes.
 */
export const getDashboardSummary = async (): Promise<DashboardSummary> => {
    try {
        const response = await api.get<ApiResponse<DashboardSummary>>(API_ROUTES.dashboard.getSummary);
        if (!response.data.success || !response.data.data) {
            throw new Error(response.data.message || "No se pudo cargar la información del dashboard.");
        }
        return response.data.data;
    } catch (error) {
        throw handleApiError(error);
    }
};